import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { EmbedRoute } from "./routes/EmbedRoute";
import { BookRoute } from "./routes/BookRoute";
import { TyreRoute } from "./routes/TyreRoute";

/**
 * Two surfaces over one <BookingFlow/>:
 *  - /embed?garage=<id>   chrome-less, for the iframe
 *  - /book/:garageId      standalone branded page
 */
export function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        <Route path="/embed" element={<EmbedRoute />} />
        <Route path="/book/:garageId" element={<BookRoute />} />
        <Route path="/tyres/:garageId" element={<TyreRoute />} />
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

/** Minimal index — the app is normally reached via /embed or /book/:id. */
function Landing() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 40,
        textAlign: "center",
        color: "var(--ap-ink-soft)",
        fontFamily: "var(--ap-body)",
      }}
    >
      <div>
        <h1
          style={{
            fontFamily: "var(--ap-display)",
            fontSize: 32,
            color: "var(--ap-green-deep)",
            marginBottom: 12,
          }}
        >
          Autopic Booking
        </h1>
        <p>
          Open a booking surface at <code>/book/&lt;garageId&gt;</code> — e.g.{" "}
          <a href="book/demo-sandbox">/book/demo-sandbox</a>.
        </p>
      </div>
    </div>
  );
}
